import { relations } from 'drizzle-orm';
import { consultations } from '../models/consultations';
import { users } from '../../user/models/users';

/**
 * @group Patient
 * @summary Consultation relations for the database schema
 *
 * @remarks
 * Defines the relationships for the consultations table, including the many-to-one
 * relationship with users for patient consultations.
 *
 * @example
 * ```typescript
 * import { consultationRelations } from '@shared/db';
 *
 * // Query consultation with user details
 * const consultationWithUser = await db.query.consultations.findFirst({
 *   where: eq(consultations.id, consultationId),
 *   with: {
 *     user: true
 *   }
 * });
 * 
 * // Query user with all consultations
 * const userWithConsultations = await db.query.users.findFirst({
 *   where: eq(users.id, userId),
 *   with: {
 *     consultations: true
 *   }
 * });
 * ```
 */
export const /**
 * @internal
 */
consultationRelations = relations(consultations, ({ one }) => ({
  user: one(users, {
    fields: [consultations.user_id],
    references: [users.id],
  }),
  clinician: one(users, {
    fields: [consultations.clinician_user_id],
    references: [users.id],
    relationName: 'consultationClinician',
  }),
}));
